"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _coreDecorators = require("core-decorators");

var _elementResizeDetector = _interopRequireDefault(require("element-resize-detector"));

var _styles = _interopRequireDefault(require("./styles"));

var _class, _class2, _temp;

var erd = (0, _elementResizeDetector.default)({
  strategy: 'scroll'
});
var Expandable = (_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Expandable, _React$PureComponent);

  function Expandable() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Expandable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Expandable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      wrapHeight: undefined,
      inTransition: false
    });
    return _this;
  }

  (0, _createClass2.default)(Expandable, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.visible !== nextProps.visible) {
        this.setState({
          inTransition: true
        });
      }
    }
  }, {
    key: "rootRef",
    value: function rootRef(element) {
      var _this2 = this;

      if (element) {
        element.addEventListener('transitionend', function (e) {
          if (e.target === element && e.propertyName === 'opacity') {
            _this2.setState({
              inTransition: false
            });
          }
        });
      }
    }
  }, {
    key: "wrapRef",
    value: function wrapRef(element) {
      var _this3 = this;

      var erdListener = function erdListener(e) {
        _this3.setState({
          wrapHeight: e.offsetHeight
        });
      };

      if (element) {
        erd.listenTo(element, erdListener);
      } else {
        erd.removeListener(erdListener);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          visible = _this$props.visible,
          children = _this$props.children;
      var _this$state = this.state,
          wrapHeight = _this$state.wrapHeight,
          inTransition = _this$state.inTransition;
      return _react.default.createElement("div", {
        ref: this.rootRef,
        className: _styles.default.root(visible),
        style: {
          height: visible ? wrapHeight + 'px' : '0',
          overflowY: !visible || inTransition ? 'hidden' : undefined
        }
      }, _react.default.createElement("div", {
        ref: this.wrapRef
      }, children));
    }
  }]);
  return Expandable;
}(_react.default.PureComponent), (0, _defineProperty2.default)(_class2, "propTypes", {
  visible: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired
}), (0, _defineProperty2.default)(_class2, "defaultProps", {
  visible: true
}), _temp), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "rootRef", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "rootRef"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "wrapRef", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "wrapRef"), _class.prototype)), _class);
var _default = Expandable;
exports.default = _default;